import React, { ReactNode } from 'react';
import { ColorSplotch } from '@repo/icons/ColorSplotch';
import { BadgeSharedWithMeIcon, BadgeStarredIcon } from '@repo/icons';
import styles from './GroupIdentifierIcon.module.scss';
import Group from '@repo/utils/models/Group';

export function GroupIdentifierIcon({
  group,
  className,
}: {
  group: Partial<Group>;
  className?: string;
}) {
  let icon: ReactNode = null;

  if (group.slug === 'starred') {
    icon = <BadgeStarredIcon />;
  } else if (group.slug === 'shared-with-me') {
    icon = <BadgeSharedWithMeIcon />;
  } else {
    icon = <ColorSplotch className={styles.color} color={group.color} />;
  }

  return <span className={className}>{icon}</span>;
}
